const STUDENT_ONLY_TYPES = ['students only'];

export default STUDENT_ONLY_TYPES;